import { GroupEditForm } from "../../organisms/form/GroupEditForm";
import { MainTemplate } from "../../templates/MainTemplate";
import { useGroupEdit } from "./hook";

export const GroupEditPage: React.FC = () => {
  const { clients, group, handleCancel, handleEditGroup } = useGroupEdit();

  return (
    <MainTemplate title="グループ編集">
      {group && (
        <GroupEditForm
          clients={clients ?? []}
          group={group}
          onCancel={handleCancel}
          handleSubmit={handleEditGroup}
        />
      )}
    </MainTemplate>
  );
};
